import React from 'react';
import {Modal} from 'react-bootstrap';

/**
 * Rückfrage-Dialog des Auftrags-Editors — Ersatz für `confirm()` und `alert()`
 * des Originals (dort an sechs Stellen benutzt: Stammlager zurücksetzen, alle
 * Positionen umstellen, Sammel-Reservierung, Massen-Verfügbarkeit, Reservierung
 * aufheben, Löschschutz der Kundeninfo). Browsereigene Dialoge sind im Haus
 * nicht zugelassen.
 *
 * In Stufe 0 gibt es noch keine verändernde Aktion; der Baustein steht bereit,
 * damit die Stufen 1–3 ihn ohne weitere Abstimmung benutzen können.
 *
 * @param {boolean} show
 * @param {string} title
 * @param {React.ReactNode} children - Erklärung, was die Bestätigung auslöst.
 * @param {string} [confirmLabel="Fortfahren"]
 * @param {string} [cancelLabel="Abbrechen"]
 * @param {"default"|"danger"} [tone="default"] - `danger` für nicht umkehrbare Schritte.
 * @param {boolean} [busy] - Sperrt die Knöpfe, solange die Aktion läuft.
 * @param {() => void} onConfirm
 * @param {() => void} onCancel
 */
export default function ConfirmDialog({
    show,
    title,
    children,
    confirmLabel = 'Fortfahren',
    cancelLabel = 'Abbrechen',
    tone = 'default',
    busy = false,
    onConfirm,
    onCancel,
}) {
    return (
        <Modal show={show} onHide={onCancel} centered backdrop="static" aria-labelledby="oe-confirm-title">
            <Modal.Header closeButton>
                <Modal.Title id="oe-confirm-title" style={{fontSize: 16}}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{fontSize: 14, lineHeight: 1.5}}>{children}</Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-outline-secondary btn-sm" disabled={busy} onClick={onCancel}>
                    {cancelLabel}
                </button>
                <button
                    type="button"
                    className={`btn btn-sm ${tone === 'danger' ? 'btn-danger' : 'btn-weclapp'}`}
                    disabled={busy}
                    onClick={onConfirm}
                >
                    {busy ? 'läuft…' : confirmLabel}
                </button>
            </Modal.Footer>
        </Modal>
    );
}
